module.exports = __webpack_public_path__ + "img/icon-phone.c650c12d.svg";